import React, { useState } from "react";
import { CreateNotification } from "../../../components/notifier";
import { DocumentContentService } from "../../../services/document/document-content.service";
import { Column } from "devextreme-react/data-grid";
import { Box } from "../../../components/box";
import TreeList, { Scrolling } from "devextreme-react/tree-list";
import { SharePointPermissionRole } from "../../../constants/sharePointConstant";
import { useSelector } from "../../../store/store";
import { IDocumentContent } from "../../../models/IDocumentContent";
import { convertUserLoginToSharepointUser, isEqualBetweenSharepointUserAndLoginUser } from "../../../services/util";
import { ISharepointUser } from "../../../models/ISharepoint";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../helper/dateTimeHelper";
import ReplyComment from "../modal/document-reply-comment-modal";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { MailService } from "../../../services/mail/mail.service";
import { downloadExcel } from "react-export-table-to-excel";
import { flattenTree, replaceHTMLtoTitle } from "../util";
import FontFa from "../../../components/fontFa/fontFa";
import { Button } from "react-bootstrap";
import { getEnv } from "../../../AppConfigs";
import { useDocumentContent } from "../hooks/document-content/use-document-content";
import { useQueryClient } from "@tanstack/react-query";
import { useDocumentInfo } from "../hooks/documents/use-document-info";
import { useSearchParams } from "../../../hook/use-search-params";
import { Spin } from "antd";

export const CommentList = () => {
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state) => state.user);
  const expandedRowKeys = [1];
  const [isOpenReplyComment, setIsOpenReplyComment] = useState(false);
  const [currentComment, setCurrentComment] = useState<any>([]);
  const [currentData, setCurrentData] = useState(null as any);
  const domain = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const { isLoading, mappedData } = useDocumentContent();
  const tree: any = mappedData ? flattenTree(mappedData, undefined) : [];
  const queryClient = useQueryClient();
  const { data: document } = useDocumentInfo();
  const { searchParams } = useSearchParams();
  const isHiddenAction = searchParams.get("action") === "process";

  const checkPermission = (data: IDocumentContent, userLogin: any) => {
    if (user.isMasterUser) return SharePointPermissionRole.write;

    //Check shareLinks are defined or not.
    //if yes, check permission
    if (
      isEqualBetweenSharepointUserAndLoginUser(data.CreatedUser, userLogin) === true ||
      isEqualBetweenSharepointUserAndLoginUser(data.ModifiedUser, userLogin) === true
    ) {
      return SharePointPermissionRole.write;
    }

    // if(!data || !data.ShareLinks || data.ShareLinks.length === 0) {
    //   if(fileShareLinks && fileShareLinks.length > 0) {
    //     return checkPermissionFromShareLinks(fileShareLinks, userLogin);
    //   }
    else {
      return SharePointPermissionRole.read;
    }
  };

  const contentCellRender = (cellInfo: any) => {
    var role = SharePointPermissionRole.read;
    if (cellInfo.data.IsContent) {
      role = checkPermission(cellInfo.data, user);
    }
    const id = `title-${cellInfo.data.Id}`;
    return (
      (role !== SharePointPermissionRole.none ||
        checkReviewers() ||
        checkDetectors() ||
        checkCheckers() ||
        checkApprovers()) && (
        <div
          id={id}
          style={{ whiteSpace: "normal", userSelect: "none" }}
          className="scroll-mt-20"
          dangerouslySetInnerHTML={{ __html: cellInfo.value }}
        />
      )
    );
  };

  const checkReviewers = () => {
    if (!document || !document.docReviewers) return false;

    return (
      document.docReviewers.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, user)) !==
      undefined
    );
  };

  const checkDetectors = () => {
    if (!document || !document.docDetectors) return false;

    return (
      document.docDetectors.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, user)) !==
      undefined
    );
  };

  const checkCheckers = () => {
    if (!document || !document.docCheckers) return false;

    return (
      document.docCheckers.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, user)) !== undefined
    );
  };

  const checkApprovers = () => {
    if (!document || !document?.approvedBy) return false;

    return (
      document?.approvedBy?.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, user)) !==
      undefined
    );
  };

  const checkPermissionReplyComment = () => {
    return document?.userDisplayName === user.current.name;
  };

  const handleReply = async (e: any, data: any) => {
    setCurrentComment(e);
    setCurrentData(data);
    setIsOpenReplyComment(!isOpenReplyComment);
  };

  const hideReplyCommentModal = () => {
    setIsOpenReplyComment(!isOpenReplyComment);
  };

  const handleCommentCellRender = (data: any) => {
    if (data && data.data) {
      let arrComments: any = data.data.Comments ? JSON.parse(data.data.Comments) : [];
      let comment: any = arrComments.map((e: any, index: number) => {
        return (
          <React.Fragment key={index}>
            <div>
              {e.User?.displayName +
                ": " +
                e.Comment +
                " (" +
                getDDMMYYYFormat(e.ModifiedDate) +
                " - " +
                getHHmmFormat(e.ModifiedDate) +
                ")"}
              {checkPermissionReplyComment() && (
                <Button
                  title={"Phản hồi"}
                  className="icon__Feedback-container btn mr-2"
                  variant="transparent"
                  onClick={() => handleReply(e, data.data)}
                  hidden={isHiddenAction}
                >
                  <FontFa className="icon__Feedback" name="faComments" size={"sm"} color={"#17a2b8"} />
                </Button>
              )}
              {/* <Button icon="comment" stylingMode='text' visible={checkPermissionReplyComment()} onClick={() => handleReply(e, data.data)}></Button> */}
            </div>
            <div>
              - Phản hồi: {e.Reply ? e.Reply.Reply : ""}
              <br />
              <br />
            </div>
          </React.Fragment>
        );
      });
      return comment;
    }
  };

  const submitReply = async (reply: any) => {
    let arrComments: any = null;
    const objReply = {
      Id: crypto.randomUUID(),
      User: convertUserLoginToSharepointUser(user),
      Reply: reply,
      CreateDate: new Date(),
      ModifiedDate: new Date(),
    };
    currentComment.Reply = objReply;
    if (currentData) {
      arrComments = JSON.parse(currentData.Comments);
      let indexComment = arrComments.findIndex((comment: any) => comment.Id === currentComment.Id);
      arrComments[indexComment] = indexComment !== -1 ? currentComment : null;
      await DocumentContentService.updateComment(currentData.Id, arrComments);
      queryClient.invalidateQueries({ queryKey: ["document-content"] });
    }
    setIsOpenReplyComment(!isOpenReplyComment);
  };

  const sendMail = async () => {
    let arrComment: any = null;
    let arr: any = [];
    let arrMail: any = [];
    let id: any = document?.docId;
    arrComment = mappedData.filter((e: any) => e.Comments).map((e: any) => JSON.parse(e.Comments));
    arrComment.map((e: any) => arr.push(...e));
    arrMail = arr.map((e: any) => {
      return {
        toMail: e.User.email,
        name: e.User.displayName,
        reply: e.Reply?.Reply,
      };
    });
    arrMail
      .filter((e: any) => e.reply)
      .map(async (e: any) => {
        const url = `${domain}/${id}?fileId=${document?.fileId}&action=comment`;
        const template = mailtemplates.find((m: any) => m.eMailType === "RDC");
        const content = template.eContent
          .replace(mailRegexs.zero, e.name)
          .replace(mailRegexs.one, e.reply)
          .replace(mailRegexs.two, document?.Title)
          .replace(mailRegexs.three, document?.docPublishViewVersion?.toString())
          .replace(mailRegexs.four, document?.docEditionVersion?.toString())
          .replace(mailRegexs.siteUrl, url);
        const subject = template.eSubject;
        MailService.sendMailByBotit({ content, subject, toMail: e.toMail });

        // const message = MailService.buildMailMesssage(subject, content, "html", e.toMail);
        // await MailService.sendMail(message);
      });
    CreateNotification({
      title: "Gửi thành công",
      body: "Đã gửi phản hồi đến tất cả",
      icon: "/icons/success.png",
    });
  };

  const getComment = (data: any) => {
    let stringComment: string = "";
    if (data && data.Comments) {
      let arrComments: any = JSON.parse(data.Comments);
      let comment: any = arrComments.map((e: any) => {
        return `${e.User?.displayName}: ${e.Comment} (${getDDMMYYYFormat(e.ModifiedDate)} - ${getHHmmFormat(
          e.ModifiedDate,
        )}
                - Phản hồi: ${e.Reply ? e.Reply.Reply : ""}
                `;
      });
      stringComment += comment;
    }
    return stringComment;
  };

  const onDownload = () => {
    const body = tree
      ? tree.map((e: any) => {
          return {
            title: e.Title ? e.Title : null,
            content: e.IsContent ? replaceHTMLtoTitle(e.Content) : null,
            comment: getComment(e),
          };
        })
      : null;

    const header = ["Tiêu đề", "Nội dung", "Ý kiến"];

    downloadExcel({
      fileName: "report",
      sheet: "itCodeRequest",
      tablePayload: {
        header,
        body: body ? body : "",
      },
    });
  };

  return (
    <>
      <div>
        <div className="pd0">
          <Box title="Danh sách ý kiến">
            <React.Fragment>
              {isLoading ? (
                <Spin />
              ) : (
                <>
                  <TreeList
                    width="100%"
                    id="content"
                    dataSource={mappedData}
                    defaultExpandedRowKeys={expandedRowKeys}
                    showRowLines={true}
                    showBorders={true}
                    columnAutoWidth={true}
                    keyExpr="CustomId"
                    parentIdExpr="CustomParentId"
                    showColumnHeaders={true}
                    showColumnLines={true}
                    autoExpandAll={true}
                    wordWrapEnabled={true}
                    loadPanel={{ enabled: true }}
                    allowColumnReordering={false}
                    allowColumnResizing={true}
                  >
                    <Scrolling mode="standard" />
                    <Column
                      fixed={true}
                      fixedPosition="left"
                      dataField="Content"
                      alignment="left"
                      headerCellRender={() => <p>Tiêu đề</p>}
                      cellRender={contentCellRender}
                      dataType="string"
                      width={isHiddenAction ? 650 : 900}
                      cssClass="white-space: normal!important"
                    ></Column>
                    <Column
                      // fixed={true}
                      fixedPosition="left"
                      allowResizing={true}
                      dataField="Comments"
                      width={481}
                      headerCellRender={() => {
                        return (
                          <>
                            <div className="opinion__excel">
                              <span>Ý kiến</span>
                              <Button
                                title={"Xuất ý kiến"}
                                className="btn mr-2"
                                variant="outline-success"
                                onClick={onDownload}
                              >
                                <FontFa name="faFileExcel" size={"xs"} />
                              </Button>
                              {/* <Button
                                                hint="Xuất excel các ý kiến"
                                                icon="xlsxfile" type="default" 
                                                stylingMode="outlined"
                                                onClick={onDownload}>
                                                </Button> */}
                            </div>
                          </>
                        );
                      }}
                      alignment="left"
                      allowSorting={false}
                      cellRender={handleCommentCellRender}
                      dataType="string"
                      allowEditing={false}
                      cssClass="white-space: normal!important"
                    ></Column>
                  </TreeList>
                  {checkPermissionReplyComment() && (
                    <div className="text-right send_feedback-container">
                      <Button
                        title={"Gửi"}
                        className="Send_feedback btn mr-2"
                        variant="outline-info"
                        onClick={sendMail}
                        hidden={isHiddenAction}
                      >
                        <FontFa name="faPaperPlane" size={"xs"} />
                        <span className="px-2">Gửi Phản hồi</span>
                      </Button>
                    </div>
                  )}
                </>
              )}
            </React.Fragment>
          </Box>
        </div>
      </div>
      <ReplyComment
        onClose={hideReplyCommentModal}
        isOpenModal={isOpenReplyComment}
        onSubmitReply={submitReply}
        currentComment={currentComment}
      />
    </>
  );
};
